/* @flow */

import arrayFrom from 'array-from';
import { toggleClasses, removeClasses } from './utils';

const ACTIVE_CLASS = 'is-active';
const NAV_ACTIVE_CLASS = 'is-navigation-active';

class Navigation {
  constructor() {
    const toggleEls = document.querySelectorAll('.js-toggle-navigation');
    const navigationEl = document.querySelector('.c-navigation');
    const navigationLinks = document.querySelectorAll('.c-navigation__link');
    const notifyEls = this.getNotifyEls(toggleEls);

    document.addEventListener('click', (event: Event) => {
      if (event.target === navigationEl) {
        return;
      }
      removeClasses(toggleEls, NAV_ACTIVE_CLASS);
      removeClasses(notifyEls, NAV_ACTIVE_CLASS);
      navigationEl && navigationEl.classList.remove(ACTIVE_CLASS);
    });

    arrayFrom(toggleEls).forEach( toggleEl => {
      toggleEl.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();

        navigationEl && navigationEl.classList.toggle(ACTIVE_CLASS);
        toggleClasses(toggleEls, NAV_ACTIVE_CLASS);
        toggleClasses(notifyEls, NAV_ACTIVE_CLASS);
      });
    }, false);

    arrayFrom(navigationLinks).forEach(link => {
      link.addEventListener('click', event => {
        arrayFrom(navigationLinks)
          .forEach(link => link.classList.remove(ACTIVE_CLASS));
        event.target.classList.add(ACTIVE_CLASS);
      }, false);
    })
  }

  getNotifyEls(elements: NodeList<HTMLElement>): NodeList<HTMLElement> {
    const selectors = arrayFrom(elements).reduce( (selectors, element) => {
      const notifySelector = element.getAttribute('data-notify-selector');

      if (notifySelector) {
        selectors.push(notifySelector);
      }

      return selectors;
    }, []);

    return document.querySelectorAll( selectors.join(',') );
  }
}

export default Navigation;
